/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   setVisitedEntity
 */

import { localStorageSingleton } from '@zcode/nr-utils'
import { createAction } from 'redux-actions'
import type { Dispatch } from '../../types'

export const SET_VISITED = 'SET_VISITED'
export const setVisited = createAction<any, typeof SET_VISITED>(SET_VISITED)

export const setVisitedEntity =
  (
    entity: {
      uId?: string | null
      buildingId?: number | null
      listingId?: number | null
      paUrl?: string | null
    },
    isGroup?: boolean
  ) =>
  (dispatch: Dispatch) => {
    if (entity) {
      const { uId, buildingId, listingId, paUrl } = entity
      if (uId || buildingId || listingId) {
        const localVisited = localStorageSingleton.get('visited') || {}
        const timestamp = Date.now()
        if (isGroup && paUrl) {
          localVisited[paUrl] = timestamp
        } else {
          if (uId) {
            localVisited[uId] = timestamp
          }
          if (buildingId) {
            localVisited[`b-${buildingId}`] = timestamp
          }
          if (listingId) {
            localVisited[`l-${listingId}`] = timestamp
          }
        }
        localStorageSingleton.set('visited', localVisited)
        dispatch(setVisited({ uId, buildingId, listingId, paUrl, isGroup }))
      }
    }
  }
